// extracted by mini-css-extract-plugin
export default {"temp":"style_temp__EPAtx","tempUnit":"style_tempUnit__E4oEH"};